import React from "react";
import { CloudHoistingData } from "../../../constants/data";

function CloudHoisting() {
  return (
    <div>
      <div className="max-w-1200 mx-auto w-full px-4">
        <div className="py-8">
          <div className="flex flex-col items-start lg:items-center md:gap-12 md:px-6">
            <div id="hosting" className={`flex flex-col items-start lg:items-center space-y-3 mt-10 lg:mx-auto  max-sm:mb-10`}>
              <h2
                className={`font-poppins text-darkPurple/90 text-left lg:text-center font-bold text-2xl leading-10 sm:text-[32px] sm:leading-[44px]`}
              >
                Cloud-Based or On-Premise Hosting
              </h2>
              <div className={`text-sm max-sm:hidden`}>
                <p
                  className={`font-poppins font-normal leading-7 text-center max-sm:mb-10`}
                >
                  With RegTechFlow, you have the flexibility to choose how your
                  data is hosted.
                </p>
              </div>
            </div>
            <div className="flex flex-col lg:flex-row">
              {CloudHoistingData.map((cloud, idx) => (
                <div
                  key={idx}
                  className="flex lg:items-start items-center flex-col-reverse gap-4"
                >
                  <div className="">
                    <img
                      src={cloud.img}
                      alt={cloud.head}
                      className="w-[230px] h-[207px] md:w-[324px] md:h-[290px] "
                    />
                  </div>
                  <div className="flex flex-col md:items-start items-start gap-2 text-black">
                    <div className="text-xl font-bold text-[#220454] lg:text-darkGray">{cloud.head}</div>
                    <div className="text-sm leading-7 font-normal md:w-[75%] w-full">
                      {cloud.title}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CloudHoisting;
